import { Badge } from '@ui/themed';
import { t } from 'i18next';
import type { ActivePlanKey } from '../../../constants/features';

export function BillingTrialBadge({
  activeBillingPlanKey,
  trialEndsInDays,
}: {
  activeBillingPlanKey?: ActivePlanKey;
  trialEndsInDays?: number;
}) {
  if (!activeBillingPlanKey || !trialEndsInDays) {
    return null;
  }

  return (
    <Badge variant="green">
      {t('features:home.components.billing_trial_badge.days_left', { count: trialEndsInDays })}
    </Badge>
  );
}
